export const TessellLabelValueStyles = {
  valueContainer: {
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    fontSize: 14,
    fontWeight: 500,
  },
};
